import script from "./CircleSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CircleSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./CircleSpinner.vue?vue&type=style&index=0&id=0d2d011d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/app-registration/app-registration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d2d011d"]])

export default __exports__